import React, { useContext, useState, useEffect } from "react";
import {
  Modal,
  Box,
  Button,
  TextField,
  CircularProgress,
  Typography,
  Grid,
} from "@mui/material";
import useCommonContext from "../../store/CommonContext";
import AuthContext from "../../store/AuthContext";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { ddmmyyyy } from "../../utils/DateUtils";
import PinInput from "react-pin-input";
import ModalHeader from "../../modals/ModalHeader";

const PayBill = ({
  open,
  handleClose,
  row,
  fetchedEnquiryReferenceId,
  setPaymentTime,
  paymentTime,
  getBillers,
}) => {
  const [amount, setAmount] = useState(row?.param3 || "");
  const [mpinVal, setMpinVal] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const authCtx = useContext(AuthContext);
  const location = authCtx.location;
  const { getRecentData, refreshUser } = useCommonContext();

  useEffect(() => {
    if (row?.param3) {
      setAmount(row.param3);
    }
  }, [row]);

  const handlePayment = () => {
    if (!mpinVal) {
      setErr("MPIN is required");
      return;
    }
    setLoading(true);
    payBill();
  };

  const payBill = () => {
    if (!fetchedEnquiryReferenceId) {
      console.log("enquiryReferenceId is not set yet.");
      return;
    }

    const data = {
      billerId: row.biller_id,
      operator: row.biller_id,
      amount: amount,
      pf: "web",
      cat: row.categoryKey,
      mpin: mpinVal,
      latitude: location.lat,
      longitude: location.long,
      enquiryReferenceId: fetchedEnquiryReferenceId,
    };

    ["param1", "param2", "param3", "param4"].forEach((param) => {
      const value = row[param];
      if (value !== undefined && value !== null && value !== "") {
        data[param] = value;
      }
    });

    postJsonData(
      ApiEndpoints.RECH_PAY_BILL,
      data,
      setLoading,
      (res) => {
        okSuccessToast(res.data.message);
        getRecentData();

        const currentDate = new Date().toLocaleDateString("en-GB"); // dd/mm/yyyy
        updateBiller(currentDate);
        setPaymentTime(currentDate);

        setErr("");
        handleClose();
      },
      (error) => {
        setErr(error.message || "Something went wrong");
        setLoading(false);
        apiErrorToast(error);
        getRecentData();
      }
    );

    refreshUser();
  };

  const updateBiller = (paidTime) => {
    const formatDate = (date) => {
      const [day, month, year] = date?.split("/") || [null, null, null];
      if (!day || !month || !year) return null;

      return `${year}-${month}-${day}`;
    };

    const data = {
      id: row.id,
      billerId: row.biller_id,
      operator: row.biller_id,
      amount: amount,
      pf: "web",
      cat: row.categoryKey,
      mpin: mpinVal,
      latitude: location.lat,
      longitude: location.long,
      last_paid: formatDate(paidTime),
    };

    postJsonData(
      ApiEndpoints.UPDATE_BILLER,
      data,
      setLoading,
      (res) => {
        okSuccessToast(res.data.message);
        getRecentData();
        getBillers();
      },
      (error) => {
        setErr(error.message || "Something went wrong");
        apiErrorToast(error);
        getRecentData();
      }
    );
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 24,
          padding: 3,
        }}
      >
        <ModalHeader title="Pay Bill" handleClose={handleClose} />

        <Grid container direction="column" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <TextField
              label="Param1"
              value={row?.param1 || "N/A"}
              fullWidth
              margin="normal"
              disabled
            
            />
          </Grid>

          <Grid item>
            <TextField
              label="Param2"
              value={row?.param2 || "N/A"}
              fullWidth
              margin="normal"
              disabled
          
            />
          </Grid>

          <Grid item>
            <TextField
              label="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              fullWidth
              margin="normal"
              type="number"
           
            />
          </Grid>

          <Grid item>
            <TextField
              fullWidth
              label="Due Date"
              value={ddmmyyyy(row?.due_date) || "N/A"}
              InputProps={{ readOnly: true }}
              sx={{ mb: 2 }}
            />
          </Grid>

          <Grid item>
            <TextField
              fullWidth
              label="Generated Date"
              value={ddmmyyyy(row?.generated_date) || "N/A"}
              InputProps={{ readOnly: true }}
              sx={{ mb: 2 }}
            />
          </Grid>

          <Grid item>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Enter MPIN (Required):
            </Typography>
            <PinInput
              length={6}
              autoComplete="off"
              focus
              type="password"
              onChange={(value) => {
                if (err !== "") setErr("");
                setMpinVal(value);
              }}
              regexCriteria={/^[0-9]*$/}
              inputStyle={{
                width: "50px",
                height: "50px",
                marginRight: "10px",
                textAlign: "center",
                borderRadius: "8px",
                border: "1px solid #ccc",
                borderBottom: "1px solid #000",
                padding: "8px",
                outline: "none",
              }}
            />
            {err && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {err}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="secondary"
            disabled={loading}
            sx={{ width: "48%" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handlePayment}
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{ width: "48%" }}
          >
            {loading ? <CircularProgress size={24} /> : `Pay ₹${amount}`}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PayBill;
